export default {
  actionIcon: 'StarIcon',
  highlightColor: 'warning',
  data: [
    {index: 0, label: 'Home', url: '/', labelIcon: 'HomeIcon', highlightAction: false},
    {index: 1, label: 'Page 2', url: '/page2', labelIcon: 'CalendarIcon', highlightAction: false},

    // APPS
    {index: 5, label: 'Calendar', url: '/apps/calendar/vue-simple-calendar', labelIcon: 'CalendarIcon', highlightAction: true},

    // EXTENSIONS
    {index: 76, label: 'Datepicker', url: '/extensions/datepicker', labelIcon: 'CalendarIcon', highlightAction: false},
  ]
}
